(function () {
  var activeVideos = [];

  function pauseOthers(current) {
    for (var i = 0; i < activeVideos.length; i++) {
      var v = activeVideos[i];
      if (v && v !== current && !v.paused) {
        try { v.pause(); } catch (e) { /* ignore */ }
      }
    }
  }

  function formatDuration(totalSeconds) {
    if (!isFinite(totalSeconds) || totalSeconds <= 0) return '';
    var secs = Math.round(totalSeconds);
    var mins = Math.floor(secs / 60);
    var rem = secs % 60;
    return mins + ':' + (rem < 10 ? '0' + rem : rem);
  }

  function updateDurationChip(thumb, video) {
    var chip = thumb.querySelector('[data-psr-duration]');
    if (!chip) return;
    var formatted = formatDuration(video.duration);
    if (formatted) {
      chip.textContent = formatted;
      chip.removeAttribute('hidden');
    }
  }

  function preloadDuration(thumb) {
    var chip = thumb.querySelector('[data-psr-duration]');
    if (!chip) return;

    var template = thumb.querySelector('template[data-psr-video]');
    if (!template) return;

    var sourceEl = template.content.querySelector('source[src], video[src]');
    var src = sourceEl ? sourceEl.getAttribute('src') : null;
    if (!src) return;

    var probe = document.createElement('video');
    probe.preload = 'metadata';
    probe.muted = true;
    probe.src = src;
    probe.addEventListener('loadedmetadata', function () {
      updateDurationChip(thumb, probe);
    });
  }

  function initThumb(thumb) {
    if (thumb.dataset.psrInit === '1') return;
    thumb.dataset.psrInit = '1';

    preloadDuration(thumb);

    var btn = thumb.querySelector('.psr-play-btn');
    if (!btn) return;

    var template = thumb.querySelector('template[data-psr-video]');
    if (!template) return;

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      var clone = template.content.cloneNode(true);
      thumb.classList.add('is-playing');
      thumb.appendChild(clone);

      var video = thumb.querySelector('video');
      if (!video) return;

      activeVideos.push(video);

      video.addEventListener('play', function () {
        pauseOthers(video);
      });

      video.addEventListener('loadedmetadata', function () {
        updateDurationChip(thumb, video);
      });

      if (typeof video.play === 'function') {
        try { video.play(); } catch (e) { /* user-initiated, browser will allow */ }
      }
    });
  }

  function init(root) {
    var thumbs = (root || document).querySelectorAll('.psr-video-thumb');
    thumbs.forEach(initThumb);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
